<template>
  <section>
    <p class="text-center pl-5 pr-5 pt-3"><q><em>{{ quote }}</em></q></p>
    <div class="d-flex justify-content-center mt-2">
      <h1 class="w-95 pt-2 pb-2 bg-color-grey rounded text-center text-white font-size-xxl">Insurance Form</h1>
    </div>
    <div class="ml-4 ml-md-4 ml-lg-5 w-90">
      <div class="d-flex justify-content-between">
        <form class="form-group mb-2 w-sm-50 w-md-40">
          <label for="clientTypeInsurance"></label>
          <select v-model="selectedTypeInsurance" class="form-control font-italic" name="clientTypeInsurance" id="clientTypeInsurance">
            <option :key="component" :value="component" v-for="(insuranceType, component) of insuranceTypes">
              {{ insuranceType }} Insurance
            </option>
          </select>
        </form>
        <div class="d-flex align-self-end mb-2">
          <router-link to="/insurancedetails">
            <button type="button" class="btn btn-sm btn-outline-dark">
              <font-awesome-icon icon="eye" class="text-color-grey"/>
              <span>View Previous Data</span>
            </button>
          </router-link>
        </div>
      </div>
      <hr class="mt-0 bg-color-grey">
      <keep-alive>
        <component :is="selectedTypeInsurance" :insuranceType="selectedTypeInsurance" defaultFontStyle="font-italic"></component>
      </keep-alive>
    </div>
  </section>
</template>

<script>
import DefaultContent from './shared/insurances/forms/DefaultContent'
import InsuranceFormAuto from './shared/insurances/forms/InsuranceFormAuto'
import InsuranceFormCyber from './shared/insurances/forms/InsuranceFormCyber'
import InsuranceFormHome from './shared/insurances/forms/InsuranceFormHome'
import InsuranceFormPrize from './shared/insurances/forms/InsuranceFormPrize'

export default {
  name: 'InsuranceForm',
  components: {
    AppDefaultContent: DefaultContent,
    AppInsuranceFormAuto: InsuranceFormAuto,
    AppInsuranceFormCyber: InsuranceFormCyber,
    AppInsuranceFormHome: InsuranceFormHome,
    AppInsuranceFormPrize: InsuranceFormPrize
  },
  data () {
    return {
      quote: this.$store.state.quotes[Math.floor(Math.random() * this.$store.state.quotes.length)],
      selectedTypeInsurance: 'AppDefaultContent',
      insuranceTypes: {
        AppDefaultContent: 'Choose one type of insurance',
        AppInsuranceFormAuto: 'Automobile',
        AppInsuranceFormCyber: 'Cyber Liability Coverage',
        AppInsuranceFormHome: 'Home',
        AppInsuranceFormPrize: 'Prize'
      }
    }
  },
  // check if user is logged in or not.
  created () {
    this.$store.dispatch('fetchUserByEmail')
      .then()
      .catch()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/InsuranceForm.vue